import { commonDateParamMappings } from '../api/common/mappings';
import { trimAndAddAsterisk } from '../utility/QueryUtility';

export const quoteServiceMappingsE7 = [
  ...commonDateParamMappings,
  { path: 'page' },
  { path: 'size' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }) => {
      if (orderBy && order) {
        switch (orderBy) {
          case 'id':
          default:
            return `${orderBy}.keyword,${order}`;
        }
      }
      return null;
    },
  },
  {
    path: 'search',
    transform: ({ search = '' }) =>
      !search ? search : trimAndAddAsterisk(search),
  },
];
